import { Skeleton } from "@/components/ui/skeleton";

/** Generic Suspense fallback shown while a lazy route chunk loads. */
export function RouteFallback() {
  return (
    <div className="space-y-4">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
